"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _uiLibrary = require("@sm360/ui-library");

var _lodash = require("lodash");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18nify = require("react-i18nify");

var _SectionStatus = _interopRequireDefault(require("../../constants/SectionStatus.js"));

var _QuestionsListHelpers = require("../../helpers/QuestionsListHelpers");

var _Section = _interopRequireDefault(require("./Section"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var LocaleService = {
  t: _reactI18nify.translate
}; // Collapsable feature: generate an object representing the completion state of each section (NOT STARTED, STARTED or COMPLETED)

var getSectionStatus = function getSectionStatus(sections, answers) {
  return Object.keys(sections).reduce(function (acc, section) {
    var currentSection = sections[section];
    var currentSectionModel = {
      sections: (0, _defineProperty2.default)({}, section, currentSection)
    };
    var questionsCount = (0, _QuestionsListHelpers.countTotalQuestions)(answers, currentSectionModel);
    var answersCount = (0, _QuestionsListHelpers.countAnsweredQuestions)(answers, currentSectionModel); // Initially consider all sections as started

    var sectionStatus = _SectionStatus.default.STARTED;
    if (questionsCount === answersCount) sectionStatus = _SectionStatus.default.COMPLETED;else if (answersCount > 0) sectionStatus = _SectionStatus.default.STARTED;
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, section, sectionStatus));
  }, {});
};

var Sections = function Sections(_ref) {
  var sections = _ref.sections,
      answers = _ref.answers,
      getQuestions = _ref.getQuestions,
      collapsable = _ref.collapsable,
      onSectionSave = _ref.onSectionSave,
      onSave = _ref.onSave,
      noHeader = _ref.noHeader,
      editing = _ref.editing,
      children = _ref.children,
      allSectionsCompleted = _ref.allSectionsCompleted;

  // Collapsable feature: current status of each section
  var _useState = (0, _react.useState)(getSectionStatus(sections, answers)),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      sectionsStatus = _useState2[0],
      setSectionsStatus = _useState2[1]; // Collapsable feature: current expand state of each section


  var _useState3 = (0, _react.useState)(Object.keys(sections).reduce(function (acc, section) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, section, false));
  }, {})),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      sectionsIsOpen = _useState4[0],
      setSectionsIsOpen = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      confirmationModalOpen = _useState6[0],
      setConfirmationModalOpen = _useState6[1]; // Refresh sections status when answers change


  (0, _react.useEffect)(function () {
    if (collapsable) setSectionsStatus(getSectionStatus(sections, answers));
  }, [sections, answers, collapsable]);

  var setSectionOpen = function setSectionOpen(section, isOpen) {
    setSectionsIsOpen(function (prevSectionsIsOpen) {
      return _objectSpread(_objectSpread({}, prevSectionsIsOpen), {}, (0, _defineProperty2.default)({}, section, isOpen));
    });
  };

  var isSectionNotStarted = function isSectionNotStarted(section) {
    return (sectionsStatus === null || sectionsStatus === void 0 ? void 0 : sectionsStatus[section]) === _SectionStatus.default.NOT_STARTED;
  };

  var isSectionStarted = function isSectionStarted(section) {
    return (sectionsStatus === null || sectionsStatus === void 0 ? void 0 : sectionsStatus[section]) === _SectionStatus.default.STARTED;
  };

  var isSectionCompleted = function isSectionCompleted(section) {
    return (sectionsStatus === null || sectionsStatus === void 0 ? void 0 : sectionsStatus[section]) === _SectionStatus.default.COMPLETED;
  };

  var scrollToSection = function scrollToSection(section) {
    if (window) {
      var sectionExpander = window.document.getElementById("question-section-".concat(section));

      if (sectionExpander) {
        setTimeout(function () {
          sectionExpander.scrollIntoView({
            behavior: 'smooth'
          });
        }, 300);
      }
    }
  };

  var expandFirstUncompletedSection = function expandFirstUncompletedSection() {
    var firstUncompletedSection = Object.keys(sectionsStatus).find(function (section) {
      return isSectionNotStarted(section) || isSectionStarted(section);
    });

    if (firstUncompletedSection) {
      setSectionOpen(firstUncompletedSection, true); // scrollToSection(firstUncompletedSection);
    }
  }; // Automatically open the first uncompleted section when mounting the component


  (0, _react.useEffect)(function () {
    if (collapsable && editing) expandFirstUncompletedSection(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsable, editing]);

  var handleOnNext = function handleOnNext(section) {
    var isSectionValid = !editing || onSectionSave(section);

    if (isSectionValid) {
      var sectionsKeys = Object.keys(sectionsStatus);
      var activeSectionIndex = sectionsKeys.indexOf(section);

      if (activeSectionIndex >= 0 && activeSectionIndex < sectionsKeys.length) {
        // Find the next section
        var nextSectionIndex = activeSectionIndex + 1;
        var nextSection = sectionsKeys[nextSectionIndex];

        if (editing) {
          // Find the next uncompleted section
          while (isSectionCompleted(nextSection)) {
            nextSectionIndex += 1;
            nextSection = sectionsKeys === null || sectionsKeys === void 0 ? void 0 : sectionsKeys[nextSectionIndex];
          }
        } // Close current section


        setSectionOpen(section, false); // Open next section if found

        if (nextSection) {
          setSectionOpen(nextSection, true);
          scrollToSection(nextSection);
        }
      }

      var allCompleted = Object.keys(sectionsStatus).every(function (selectedSection) {
        return isSectionCompleted(selectedSection);
      });
      if (allCompleted) allSectionsCompleted(true);
    }
  };

  var handleOnSave = function handleOnSave() {
    var isValid = function isValid(section) {
      return isSectionStarted(section) || isSectionNotStarted(section) || isSectionCompleted(section);
    }; // Collapse all valid section


    Object.keys(sectionsStatus).forEach(function (section) {
      if (isValid(section)) setSectionOpen(section, false);
    }); // Validate each section

    var allValid = Object.keys(sectionsStatus).every(isValid);
    var allCompleted = Object.keys(sectionsStatus).every(function (section) {
      return isSectionCompleted(section);
    }); // If all sections are valid, trigger the form submit

    if (collapsable) {
      if (allValid) {
        // If not all sections are completed, user has to confirm save
        if (!allCompleted) setConfirmationModalOpen(true);else onSave();
      } // Else trigger expand and validation of all STARTED sections
      else {
        Object.keys(sectionsStatus).forEach(function (section) {
          if (isSectionStarted(section)) {
            onSectionSave(section);
            setSectionOpen(section, true);
          }
        });
      }
    } // Trigger it without sections validation if section are not collapsable
    else onSave();
  };

  var sectionComponents = Object.keys(sections).map(function (section, index) {
    var baseI18nKey = "QUESTIONNAIRE.".concat(section).toUpperCase();
    var title = LocaleService.t("".concat(baseI18nKey, "_SECTION_TITLE"));
    return /*#__PURE__*/_react.default.createElement(_Section.default, {
      name: section,
      title: title,
      number: index,
      key: index,
      noHeader: noHeader,
      collapsable: collapsable,
      status: sectionsStatus[section],
      onNext: handleOnNext,
      isOpen: sectionsIsOpen[section],
      setIsOpen: function setIsOpen(isOpen) {
        return setSectionOpen(section, isOpen);
      }
    }, getQuestions(sections[section].questions, baseI18nKey, 0));
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_uiLibrary.CardSection, null, sectionComponents), children && children(handleOnSave), collapsable && /*#__PURE__*/_react.default.createElement(_uiLibrary.Modal, {
    modalTitle: LocaleService.t('COLLAPSABLE_UNCOMPLETED_SECTIONS_TITLE'),
    cancelButtonLabel: LocaleService.t('OFFICIAL_EVALUATION.BUTTONS.CANCEL'),
    confirmButtonLabel: LocaleService.t('OFFICIAL_EVALUATION.BUTTONS.CONFIRM'),
    isModalOpen: confirmationModalOpen,
    modalScopeCSS: "crm",
    className: "uncompleted-sections-modal",
    onConfirm: function onConfirm() {
      setConfirmationModalOpen(false);
      onSave();
    },
    onCancel: function onCancel() {
      return setConfirmationModalOpen(false);
    },
    onClose: function onClose() {
      return setConfirmationModalOpen(false);
    }
  }, function () {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, LocaleService.t('COLLAPSABLE_UNCOMPLETED_SECTIONS_CONFIRMATION')), /*#__PURE__*/_react.default.createElement("div", null, LocaleService.t('COLLAPSABLE_UNCOMPLETED_SECTIONS_SAVE_CONFIRMATION')), /*#__PURE__*/_react.default.createElement("div", {
      className: "uk-modal__actions"
    }, /*#__PURE__*/_react.default.createElement(_uiLibrary.Button, {
      className: "",
      color: "primary",
      outline: true,
      displayAsLink: true,
      label: LocaleService.t('OFFICIAL_EVALUATION.BUTTONS.CANCEL'),
      onClick: function onClick() {
        return setConfirmationModalOpen(false);
      }
    }), /*#__PURE__*/_react.default.createElement(_uiLibrary.Button, {
      color: "primary",
      label: LocaleService.t('OFFICIAL_EVALUATION.BUTTONS.CONFIRM'),
      onClick: function onClick() {
        setConfirmationModalOpen(false);
        onSave();
      }
    })));
  }));
};

Sections.defaultProps = {
  sections: {},
  answers: {},
  collapsable: false,
  onSectionSave: _lodash.noop,
  onSave: _lodash.noop,
  getQuestions: _lodash.noop,
  noHeader: false,
  editing: false
};
Sections.propTypes = {
  /**
   * List of sections containing questions
   * e.g:
   * {
   *     section1: {
   *         questions: [...]
   *     },
   *     section2: {
   *         questions: [...]
   *     }
   * }
   */
  sections: _propTypes.default.object.isRequired,

  /**
   * List of answers
   * e.g:
   * {
   *     question1: false
   *     question2: "dealer"
   * }
   */
  answers: _propTypes.default.object.isRequired,

  /**
   * Function returning questions components for a given section
   */
  getQuestions: _propTypes.default.func.isRequired,

  /**
   * Make sections collapsable
   */
  collapsable: _propTypes.default.bool,

  /**
   * Callback function onSectionSave
   * Should trigger the validation of a section and return true if valid
   * Invoked when clicking on Next button of a section
   */
  onSectionSave: _propTypes.default.func,

  /**
   * Callback function onSave
   * Invoked when saving the whole form (when `handleOnSave` is called by children)
   * /!\ Only available when sections are `collapsable`
   */
  onSave: _propTypes.default.func,

  /**
   * Hide each section header (effective only when `collapsable` = false)
   */
  noHeader: _propTypes.default.bool,

  /**
   * Make each section editable
   */
  editing: _propTypes.default.bool,

  /**
   * Callback function onAllSectionsCompleted
   * Should trigger once all sections are completed before save to tradeIn
   * This will flag to wigets project about all completed sections
   */
  allSectionsCompleted: _propTypes.default.func,

  /**
   * Function returning a React component
   * The `handleOnSave` handler is passed to this function
   * Used for displaying a Save button
   */
  children: _propTypes.default.any
};
var _default = Sections;
exports.default = _default;